const mdpConfig = require('../../mdp.config');


const addProductsGlobalId = (id, config) => {
  let newId;
  config.globalId = id; // eslint-disable-line
  if (config.routes) {
    config.routes.forEach((route) => {
      newId = id !== '' ? `${id}|${route.id}` : route.id;
      addProductsGlobalId(newId, route);
    });
  }
  if (config.products) {
    config.products.forEach((product) => {
      newId = id !== '' ? `${id}|${product.id}` : product.id;
      product.globalId = newId; // eslint-disable-line
      if (product.zooms) {
        product.zooms.forEach((zoom) => {
          newId = id !== '' ? `${id}|${product.id}|${zoom.id}` : zoom.id;
          zoom.globalId = newId; // eslint-disable-line
        });
      }
    });
  }
};

export const serverInit = async ({ commit }, version) => { // eslint-disable-line
  const config = mdpConfig[version];
  commit('setVersion', version);
  addProductsGlobalId('', config);
  commit('setConfig', config);
  commit('setInit', true);
};

